var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { CellRenderer } from './cell-renderer';
import { appendChildren, templateCompiler } from '../base/util';
/**
 * GroupCaptionCellRenderer class which responsible for building group caption cell.
 * @hidden
 */

var GroupCaptionCellRenderer =
/** @class */
function (_super) {
  __extends(GroupCaptionCellRenderer, _super);

  function GroupCaptionCellRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.element = _this.parent.createElement('TD', {
      className: 'e-groupcaption',
      attrs: {
        id: _this.parent.element.id + 'captioncell',
        role: 'gridcell',
        tabindex: '-1'
      }
    });
    return _this;
  }
  /**
   * Function to render the cell content based on Column object.
   * @param  {Cell} cell
   * @param  {Object} data
   */


  GroupCaptionCellRenderer.prototype.render = function (cell, data) {
    var node = this.element.cloneNode();
    var gObj = this.parent;
    var result;
    var helper = {};
    var fKeyValue;
    data.headerText = cell.column.headerText;

    if (cell.isForeignKey) {
      fKeyValue = this.format(cell.column, cell.column.valueAccessor('foreignKey', data, cell.column));
    }

    var value = cell.isForeignKey ? fKeyValue : cell.column.enableGroupByFormat ? data.key : this.format(cell.column, cell.column.valueAccessor('key', data, cell.column));

    if (!isNullOrUndefined(gObj.groupSettings.captionTemplate)) {
      var isReactCompiler = this.parent.isReact && typeof gObj.groupSettings.captionTemplate !== 'string';

      if (isReactCompiler) {
        var tempID = gObj.element.id + 'captionTemplate';
        templateCompiler(gObj.groupSettings.captionTemplate)(data, this.parent, 'captionTemplate', tempID, null, null, node);
        this.parent.renderTemplates();
      } else if (this.parent.isVue) {
        result = templateCompiler(gObj.groupSettings.captionTemplate)(data, this.parent);
      } else {
        result = templateCompiler(gObj.groupSettings.captionTemplate)(data);
      }

      if (!isReactCompiler) {
        appendChildren(node, result);
      }
    } else {
      if (gObj.groupSettings.enableLazyLoading) {
        node.innerHTML = cell.column.headerText + ': ' + value;
      } else {
        node.innerHTML = cell.column.headerText + ': ' + value + ' - ' + data.count + ' ' + (data.count < 2 ? this.localizer.getConstant('Item') : this.localizer.getConstant('Items'));
      }
    }

    node.setAttribute('colspan', cell.colSpan.toString());
    node.setAttribute('aria-label', node.innerHTML + ' is groupcaption cell');
    node.setAttribute('title', node.innerHTML);
    return node;
  };

  return GroupCaptionCellRenderer;
}(CellRenderer);

export { GroupCaptionCellRenderer };
/**
 * GroupCaptionEmptyCellRenderer class which responsible for building group caption empty cell.
 * @hidden
 */

var GroupCaptionEmptyCellRenderer =
/** @class */
function (_super) {
  __extends(GroupCaptionEmptyCellRenderer, _super);

  function GroupCaptionEmptyCellRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.element = _this.parent.createElement('TD', {
      className: 'e-groupcaption'
    });
    return _this;
  }
  /**
   * Function to render the cell content based on Column object.
   * @param  {Cell} cell
   * @param  {Object} data
   */


  GroupCaptionEmptyCellRenderer.prototype.render = function (cell, data) {
    var node = this.element.cloneNode();
    node.innerHTML = '&nbsp;';
    node.setAttribute('colspan', cell.colSpan.toString());
    return node;
  };

  return GroupCaptionEmptyCellRenderer;
}(CellRenderer);

export { GroupCaptionEmptyCellRenderer };